const isAuthGloballyDisabled =
  process.env.NEXT_PUBLIC_AUTH_DISABLED === "true" ||
  process.env.NEXT_PUBLIC_AUTH_ENABLED === "false";

export const DEFAULT_AUTH_CALLBACK_PATH = "/my-orders";

const getWebOrigin = () => {
  const siteUrl = process.env.NEXT_PUBLIC_WEB_URL;

  if (!siteUrl) {
    return "";
  }

  try {
    return new URL(siteUrl).origin;
  } catch {
    return "";
  }
};

export function resolveAuthCallbackUrl(
  callbackUrl?: string | string[] | null
): string {
  const candidate = Array.isArray(callbackUrl) ? callbackUrl[0] : callbackUrl;

  if (!candidate) {
    return DEFAULT_AUTH_CALLBACK_PATH;
  }

  if (candidate.startsWith("/") && !candidate.startsWith("//")) {
    return candidate;
  }

  try {
    const url = new URL(candidate);
    const webOrigin = getWebOrigin();

    if (webOrigin && url.origin === webOrigin) {
      return `${url.pathname}${url.search}${url.hash}`;
    }
  } catch {
    return DEFAULT_AUTH_CALLBACK_PATH;
  }

  return DEFAULT_AUTH_CALLBACK_PATH;
}

export function buildSignInHref(callbackUrl?: string | string[] | null): string {
  const resolvedCallbackUrl = resolveAuthCallbackUrl(callbackUrl);
  return `/auth/signin?callbackUrl=${encodeURIComponent(resolvedCallbackUrl)}`;
}

export function isGoogleAuthEnabled(): boolean {
  return !!(
    !isAuthGloballyDisabled &&
    process.env.NEXT_PUBLIC_AUTH_GOOGLE_ENABLED !== "false" &&
    process.env.NEXT_PUBLIC_AUTH_GOOGLE_ID
  );
}

export function isGitHubAuthEnabled(): boolean {
  return !!(
    !isAuthGloballyDisabled &&
    process.env.NEXT_PUBLIC_AUTH_GITHUB_ENABLED === "true"
  );
}

export function isGoogleOneTapEnabled(): boolean {
  return !!(
    !isAuthGloballyDisabled &&
    process.env.NEXT_PUBLIC_AUTH_GOOGLE_ONE_TAP_ENABLED === "true" &&
    process.env.NEXT_PUBLIC_AUTH_GOOGLE_ID
  );
}

export function isAuthEnabled(): boolean {
  if (isAuthGloballyDisabled) {
    return false;
  }

  return (
    isGoogleAuthEnabled() ||
    isGitHubAuthEnabled() ||
    isGoogleOneTapEnabled()
  );
}
